<template>

  <div class="form-group">
    <label class="form-control-label" :for="'select-' + this._uid" v-if="!hideLabel">
      <slot></slot> <span v-if="required" class="required" data-toggle="tooltip" data-placement="bottom" title="Required">*</span>
    </label>
    <select class="form-control"
      :id="`select-${this._uid}`"
      data-minimum-results-for-search="10"
      data-placeholder="None"
      data-allow-clear="true"
      style="width: 100%">
      <option value=""></option>
    </select>
    <div v-if="error" class="invalid-feedback">{{ error.message }}</div>
  </div>

</template>

<script>
/* eslint-disable no-undef */
export default {
  name: "vue-ez-select2",
  props: ["options", "value", "error", "hideLabel", "required"],
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();

    if (this.options.length > 0) {
      var vm = this;
      $(`#select-${this._uid}`)
        .select2({
          data: this.options
        })
        .val(this.value)
        .trigger("change")
        .on("change", function() {
          vm.$emit("input", this.value);
        });
    } else {
      $(`#select-${this._uid}`).select2();
    }

    // console.log(`mounted options: ${this.options.length}`)
    // console.log(`mounted value: ${this.value}`)
  },
  watch: {
    value: function(value) {
      $(`#select-${this._uid}`)
        .val(value)
        .trigger("change");
    },
    options: function(options) {
      var vm = this;
      $(`#select-${this._uid}`)
        .select2({
          data: options
        })
        .val(this.value)
        .trigger("change")
        .on("change", function() {
          vm.$emit("input", this.value);
        });
    }
  },
  destroyed() {
    $(`#select-${this._uid}`)
      .off()
      .select2("destroy");
  }
};
</script>

<style lang="scss">
.invalid-feedback {
  display: block;
}
</style>
